import { Box, Text } from '@factorialco/deprecated-design-system'
import { CardDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { CardStatusTag } from 'modules/banking/components/CardStatusTag'

export const Header: React.FC<{ card: CardDetailFragment }> = ({ card }) => {
  return (
    <Box width="full" flexDirection="row" justifyContent="spaceBetween" paddingBottom="s24">
      <Text.Normal size="300" weight="semibold" color="textPrimary">
        {i18n.t('it_management.software_setups.cards.sidebar.overview')}
      </Text.Normal>

      <Box>
        <CardStatusTag card={card} />
      </Box>
    </Box>
  )
}
